/**
 * callback to check if element comes into the view
 * @param {Array<any>} entries
 * @param {boolean} observingOnce
 * @param {any} callback
 */var intersectionCallback=(a,b)=>{a.forEach(a=>{(null===a||void 0===a?void 0:a.isIntersecting)&&b(a.target)})};/**
 * create intersection observer instance
 * @param {ObserverConfigTypes} observerConfig
 * @return {void}
 */export var getIntersectionObserver=a=>{var b=a||{},c=b.element,d=b.callback,e=b.rootMargin,f=b.threshold,g=new IntersectionObserver(a=>intersectionCallback(a,d),{rootMargin:e,threshold:f});return c&&g.observe(c),g};